import toast from 'react-hot-toast'

import getEndpoint from '@/helpers/getEndpoint'
import API from '@/services/API'

import { WellBeingContactForm } from '../types'

export async function submitContactWellBeingForm(data: WellBeingContactForm) {
  const response = await API.post(getEndpoint('CONTACT_WELL_BEING'), {
    formData: {
      contact_message: {
        name: data.name,
        company: data.body,
        email: data.email,
        phone: data.phone,
        employees: data.employees,
        body: data.body,
      },
    },
  })

  if (response.status === 'success') {
    toast.success('Sukces! Pomyślnie wysłano formularz kontaktowy.')
  } else {
    toast.error('Wystąpił błąd.')
  }
}
